import React from "react"

export default function Project(props:any) {
  return <div className='m-8 font-sans font-semibold shadow-2xl border-2 p-2'>
    <img
      className="h-96 m-auto inline-block w-auto md:hidden"
      src={`img/` + props.imgUrl}
      alt="image of Project"
    />
    <div className='inline-block w-3/4'>
      <p className='border-l-4 border-yellow-200'>{props.title}</p>
      <p className='mt-10'>{props.description}</p>
    </div>
  </div>
}
